import BooksTour from './BooksTour';

export default BooksTour;
